import {toLocalDay} from '@/lib/ReusableFunctions/Date';
import type {SpecFilter} from './types';

interface Formatter {
  format(value: number | string | Date): string;
}

interface AppliedFilter extends Pick<SpecFilter,
  'type' | 'options' | 'selected' | 'searchName' | 'minValue' | 'maxValue' | 'suffix'> {
  prefix?: string;
}

/** Keyed by filter type, so a `currency` filter is formatted by `formatters.currency`. */
type Formatters = Record<string, Formatter>;

/** What a filter's row shows for its current value. */
const describeAppliedFilter = (filter: AppliedFilter, formatters: Formatters = {}): string => {
  if (filter.type === 'options') {
    return (filter.options ?? []).filter((option) => option.selected).map((option) => option.label).join(', ');
  }
  if (filter.type === 'chips') return (filter.selected ?? []).map((item) => item.title).join(', ');
  if (filter.type === 'text') return filter.searchName ?? '';
  return `${formatBound(filter, filter.minValue, formatters)} - ${formatBound(filter, filter.maxValue, formatters)}`;
};

const formatBound = (
  filter: AppliedFilter,
  value: number | string | null | undefined,
  formatters: Formatters,
): string => {
  if (value == null || value === '') return '---';

  const formatter = formatters[filter.type];
  let formatted = formatter ? formatter.format(filter.type === 'date' ? toLocalDay(value) : value) : String(value);
  if (filter.prefix && filter.type !== 'currency') {
    formatted = `${filter.prefix}${formatted}`;
  }
  if (filter.suffix) {
    formatted = `${formatted} ${filter.suffix}`;
  }
  return formatted;
};

export {describeAppliedFilter, type AppliedFilter, type Formatters};
